import html2canvas from "html2canvas";

const waitForImage = (img) =>
  new Promise((resolve) => {
    if (img.complete && img.naturalWidth > 0) {
      resolve();
      return;
    }
    img.addEventListener("load", resolve, { once: true });
    img.addEventListener("error", resolve, { once: true });
  });

const waitForLayout = () =>
  new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });

/**
 * Capture a DOM element as a canvas (e.g. level-up card for sharing).
 * Avoids html2canvas windowWidth/scrollWidth bugs on overflow-hidden containers.
 */
export const captureElementAsCanvas = async (element, options = {}) => {
  const { scale = 2, backgroundColor = null } = options;

  const images = element.querySelectorAll("img");
  await Promise.all([...images].map(waitForImage));

  if (document.fonts?.ready) {
    await document.fonts.ready;
  }

  await waitForLayout();

  const rect = element.getBoundingClientRect();
  const width = Math.round(rect.width) || element.offsetWidth;
  const height = Math.round(rect.height) || element.offsetHeight;

  if (width < 100 || height < 100) {
    throw new Error(
      `Capture target is too small (${width}x${height}). Ensure the card is visible before sharing.`,
    );
  }

  return html2canvas(element, {
    backgroundColor,
    scale,
    useCORS: true,
    allowTaint: true,
    logging: false,
    onclone: (_doc, clonedNode) => {
      clonedNode.style.width = `${width}px`;
      clonedNode.style.maxWidth = `${width}px`;
      clonedNode.style.overflow = "visible";
    },
  });
};
